<template>
    <div>
        
    </div>
</template>

<script>
    export default {
        name:'MyTable',
        data() {
            return {
                
            }
        },

    }
</script>

<style lang="scss" scoped>

</style>